/**
 * ✅ Precision Currency Formatting for Payments
 * Handles NGN (Naira) formatting for both strings and numbers.
 * Assumes the input is the final amount (if you pass kobo, divide by 100 first).
 */

export const formatCurrency = (amount: any) => {
  // Ensure we have a number. If it's Kobo (Integer), we divide by 100.
  const numericAmount = (parseFloat(amount) || 0) / 100;

  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    // This ensures you always see ₦500.00 instead of ₦500
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericAmount);
};
/**
 * ✅ Precision Date Formatting
 * Converts ISO strings or date objects into a readable Nigerian business format.
 */
export const formatDate = (date: string | Date | null | undefined) => {
  if (!date) return "N/A";

  // Use 'en-GB' for DD/MM/YYYY style or 'undefined' for system default
  return new Date(date).toLocaleDateString("en-NG", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
